<template>
  <div class="container">
    <div style="margin-top: 55px;">
        <avatar :name="data.nickName" :url="avatar_defalut"></avatar>
    </div>
    <div class="info">
        <div v-if="lastestRecord != ''" style="color: #000000;font-size: 16px;font-weight: 600;">
            <span>{{lastestRecord}}</span>
        </div>
        <div style="margin-top: 16px;">
            <span style="color:#888888">积分</span><span>:</span><span style="color: #FF0000; font-weight: 500;">{{data.points}}</span><span style="color:#888888; margin-left: 4px;"></span>
        </div>

    </div>
  </div>
</template>

<script>
import avatar from './avatar_card.vue';
export default {
    name:'starCard',
    props:{
        data:Object
    },
    components:{
        avatar
    },  
    data(){
        return {
            lastestRecord:'没有积分记录',
            avatar_defalut: require("../../../static/images/share/avatar_default.png"),
        }
    },
    mounted(){
        if(this.data != undefined && this.data.avatar != undefined){
            this.avatar_defalut = this.data.avatar
        }
        if(this.data != undefined && this.data.hsUserPointRecordList != undefined){
            let list =  this.data.hsUserPointRecordList
            if(list.length > 0){
                this.lastestRecord = list[0].remark
            }
            
        }
        
    }
}
</script>

<style scoped>
    .container{
        display: flex;
        flex-direction: column;
        justify-content: start;
        background-color: #ffffff;
        border-radius: 24px;
        min-height: 318px;
    }
    .info{
        margin-top: 44px;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/star_card.vue